import { AbstractProvider } from './AbstractProvider';
import { MemoryProvider } from './MemoryProvider';
import { logWarning } from '../../../utils/env';

export class LocalStorageProvider extends AbstractProvider {

  static CACHE_KEY = 'LocalStorageProvider';

  memoryProvider;

  constructor(userId) {
    super(userId);
    this.testStorage();
    this.memoryProvider = new MemoryProvider(userId);
    const data = this.loadStorage();
    this.memoryProvider.patchObject(data);
  }

  async get(key, defaultValue) {
    return this.getSync(key, defaultValue);
  }

  getSync(key, defaultValue) {
    return this.memoryProvider.has(key)
      ? this.memoryProvider.get(key, defaultValue)
      : defaultValue;
  }

  async patch(key, value) {
    await this.memoryProvider.patch(key, value);
    return this.saveStorage(this.memoryProvider.data);
  }

  async patchObject(data) {
    await this.memoryProvider.patchObject(data);
    return this.saveStorage(this.memoryProvider.data);
  }

  testStorage = () => {
    window.localStorage.setItem('LocalStorageProvider_test', '0');
    window.localStorage.removeItem('LocalStorageProvider_test');
  }

  loadStorage = () => {
    return JSON.parse(window.localStorage.getItem(LocalStorageProvider.CACHE_KEY));
  }

  saveStorage = (data) => {
    try {
      window.localStorage.setItem(LocalStorageProvider.CACHE_KEY, JSON.stringify(data));
      return true;
    } catch (e) {
      logWarning(e);
    }
    return false;
  }
}
